 

function ConvertToNumberFactory(): ng.IDirective {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel: any) {
            ngModel.$parsers.push(function (val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function (val) {
                return '' + val;
            });
        }
    };
};

angular
.module('app')
.directive('convertToNumber', ConvertToNumberFactory);